import weekStarterArray from '../utils/weekStarterArray';
export default function getCalendarPropsData(calendarsProps) {
    return {
        isPrivateEventsShown: calendarsProps.isPrivateEventsShown,
        locale: calendarsProps.locale,
        // recurrenceArr: calendarsProps.recurrenceArr,
        calendarsList: calendarsProps.calendarsList,
        privetEventsTitle: calendarsProps.privetEventsTitle,
        isMobile: calendarsProps.isMobile,
        onEventExpanded: calendarsProps.onEventExpanded,
        timeFormat: calendarsProps.timeFormat,
        onCopyClick: calendarsProps.onCopyClick,
        onLocationClick: calendarsProps.onLocationClick,
        onAttachmentClick: calendarsProps.onAttachmentClick,
        experiments: calendarsProps.experiments,
        firstDay: weekStarterArray.indexOf(calendarsProps.weekStarter),
        weekStarter: calendarsProps.weekStarter,
        action: calendarsProps.action,
        dates: calendarsProps.dates,
        timezone: calendarsProps.timezone,
        handleMonthChange: calendarsProps.handleMonthChange,
        onTodayClick: calendarsProps.onTodayClick,
        calendarRefFromWidget: calendarsProps.calendarRef,
        wixStyles: calendarsProps.wixStyles,
        isTimezoneShown: calendarsProps.isTimezoneShown,
        error: calendarsProps.error,
        handleSetHeight: calendarsProps.handleSetHeight,
        openPopup: calendarsProps.openPopup,
        isTodayButtonStyleSecondary: calendarsProps.isTodayButtonStyleSecondary,
    };
}
//# sourceMappingURL=getCalendarPropsData.js.map